// Start of Selection
import { useLocation } from "react-router";
import { canonicalPath } from "../utils/canonical";
import { Footer } from "../blocks/Footer/Footer";
import { MenuBottom } from "../blocks/MenuBottom/MenuBottom";
import Header from "../components/header/header";
import { ScrollBlock } from "../components/others/ScrollBlock";
import { Text } from "../components/texts/text";
import Title from "../components/texts/title";
import { UserProvider } from "../entities/user/model/UserContext";
import "../core/core.css";
import { DataProvider } from "../entities/service/model/DataContext";
import { SupportProvider } from "../entities/support/ui/SupportProvider";

const NotFound = () => {
  const currentPage = useLocation();
  const breadLinks = [
    { url: "/", name: "Главная" },
    {
      url: currentPage.pathname,
      name: "Страница не найдена",
    },
  ];

  return (
    <DataProvider>
      <title>Страница не найдена</title>
      <meta
        name="description"
        content={"Извините, страница, которую вы ищете, не найдена."}
      />
      <link
        rel="canonical"
        href={`https://hmrep.ru${canonicalPath(currentPage.pathname)}`}
      />
      <UserProvider>
        <SupportProvider>
          <div className="body">
            <ScrollBlock></ScrollBlock>
            <Header></Header>
            <div className="blocks">
              <Title>404 - Страница не найдена</Title>
              <Text>Извините, страница, которую вы ищете, не существует.</Text>
              <Footer></Footer>
            </div>
            <MenuBottom></MenuBottom>
          </div>
        </SupportProvider>
      </UserProvider>
    </DataProvider>
  );
};

export default NotFound;
